<template>
    <div>
        <page-header
            :title="$t('pages.admin.equipment_order.title')"
            icon-class="mdi mdi-truck"
        />
        <div
            class="card mb-4 shadow-sm"
            v-if="notShippedOrdersPaginationData.data && notShippedOrdersPaginationData.data.length"
        >
            <div class="card-body">
                <page-header :title="$t('pages.admin.equipment_order.not_shipped')" />

                <static-loading-indicator-icon
                    :loading="$store.getters.shouldLoadLocal"
                />
                <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Phone Number</th>
                                <th>Address</th>
                                <th>Ordered</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="order in notShippedOrdersPaginationData.data"
                            >
                                <td>
                                    {{ order.user.first_name }}
                                    {{ order.user.last_name }}
                                </td>
                                <td>
                                    {{ order.user.phone_number }}
                                </td>
                                <td>
                                    {{
                                        order.user.delivery_address[0]
                                            .address_one
                                    }}
                                    <br />
                                    {{
                                        order.user.delivery_address[0]
                                            .postal_code
                                    }},
                                    {{ order.user.delivery_address[0].city }}
                                    <br />
                                    {{
                                        order.user.delivery_address[0]
                                            .country_name
                                    }}
                                </td>
                                <td>
                                    {{
                                        $date(order.created_at).format(
                                            "DD.MM.YYYY"
                                        )
                                    }}
                                </td>
                                <td>
                                    <button
                                        class="btn btn-outline-info btn-sm float-right "
                                        @click="sendEquipment(order.id)"
                                    >
                                        <i class="mdi mdi-truck"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="mt-3">
                        <pagination
                            :data="notShippedOrdersPaginationData"
                            @pagination-change-page="
                                getAllNotShippedEquipmentOrders
                            "
                        ></pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12">
                <div class="alert alert-secondary border-dark shadow-sm">
                    {{ $t("pages.admin.equipment_order.not_shipped_empty") }}
                </div>
            </div>
        </div>
        <div
            class="card shadow-sm"
            v-if="shippedOrdersPaginationData.data && shippedOrdersPaginationData.data.length"
        >
            <div class="card-body">
                <page-header :title="$t('pages.admin.equipment_order.shipped')" />
                <static-loading-indicator-icon
                    :loading="$store.getters.shouldLoadLocal"
                />
                <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Phone Number</th>
                                <th>Address</th>
                                <th>Ordered</th>
                                <th>Shipped</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="order in shippedOrdersPaginationData.data"
                            >
                                <td>
                                    {{ order.user.first_name }}
                                    {{ order.user.last_name }}
                                </td>
                                <td>
                                    {{ order.user.phone_number }}
                                </td>
                                <td>
                                    {{
                                        order.user.delivery_address[0]
                                            .address_one
                                    }}
                                    <br />
                                    {{
                                        order.user.delivery_address[0]
                                            .postal_code
                                    }},
                                    {{ order.user.delivery_address[0].city }}
                                    <br />
                                    {{
                                        order.user.delivery_address[0]
                                            .country_name
                                    }}
                                </td>
                                <td>
                                    {{
                                        $date(order.created_at).format(
                                            "DD.MM.YYYY"
                                        )
                                    }}
                                </td>
                                <td>
                                    <span class="badge badge-success">
                                        <i class="mdi mdi-check"></i>
                                    </span>
                                    <span class="ml-2">
                                        {{
                                            $date(order.shipped_at).format(
                                                "DD.MM.YYYY"
                                            )
                                        }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="mt-3">
                        <pagination
                            :data="shippedOrdersPaginationData"
                            @pagination-change-page="
                                getAllShippedEquipmentOrders
                            "
                        ></pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12">
                <div class="alert alert-secondary border-dark shadow-sm">
                    {{ $t("pages.admin.equipment_order.shipped_empty") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminEquipmentOrdersRepository from "../../../repositories/Admin/AdminEquipmentOrdersRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";

export default {
    name: "EquipmentOrdersManagement",
    components: { PageHeader, StaticLoadingIndicatorIcon },
    data: () => ({
        shippedOrdersPaginationData: [],
        notShippedOrdersPaginationData: []
    }),
    mounted() {
        this.getAllShippedEquipmentOrders();
        this.getAllNotShippedEquipmentOrders();
    },
    methods: {
        getAllShippedEquipmentOrders(page = 1) {
            AdminEquipmentOrdersRepository.getAllShippedEquipmentOrders(
                page
            ).then(res => {
                this.shippedOrdersPaginationData = res.data;
            });
        },
        getAllNotShippedEquipmentOrders(page = 1) {
            AdminEquipmentOrdersRepository.getAllNotShippedEquipmentOrders(
                page
            ).then(res => {
                this.notShippedOrdersPaginationData = res.data;
            });
        },
        sendEquipment(order) {
            AdminEquipmentOrdersRepository.sendEquipment(order).then(res => {
                this.getAllShippedEquipmentOrders();
                this.getAllNotShippedEquipmentOrders();
            });
        }
    }
};
</script>

<style></style>
